module.exports = __webpack_public_path__ + "static/oval2.bf56f5c9.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/tower/oval2.png
// module id = 253
// module chunks = 0